import { render, staticRenderFns } from "./StatisticsPage.vue?vue&type=template&id=5eb46598&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb46598')) {
      api.createRecord('5eb46598', component.options)
    } else {
      api.reload('5eb46598', component.options)
    }
    module.hot.accept("./StatisticsPage.vue?vue&type=template&id=5eb46598&", function () {
      api.rerender('5eb46598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/StatisticsPage.vue"
export default component.exports